import { ReduxAsyncActionsService } from '../../../services/ReduxAsyncActions.service';
import type { WrappedReducer } from '../../../types/ReduxAsyncActions.types';
import { GET_SAN_PARTNERS_GET_AD_ACCOUNT_ZEIT_STATUS } from '../actions/getSANAdPartnerZeitStatus';
import { INIT_STATE } from './TikTok.constants';
import type { TikTokState } from './TikTok.types';
import type { TikTokAction } from './actions';
import { GET_TIKTOK_ADVERTISERS, GET_TIKTOK_AUTHENTICATION_URL } from './actions';

function handler(state: WrappedReducer<TikTokState>, action: TikTokAction): WrappedReducer<TikTokState> {
  switch (action.type) {
    case GET_SAN_PARTNERS_GET_AD_ACCOUNT_ZEIT_STATUS.response:
      const { a_tiktok_ads } = action.data || {};
      return {
        ...state,
        adAccountStatuses: a_tiktok_ads,
        loading: false,
      };

    case GET_TIKTOK_AUTHENTICATION_URL.response:
      const { url } = action.data;
      return {
        ...state,
        authenticationUrl: url,
        loading: false,
      };

    case GET_TIKTOK_ADVERTISERS.request:
      return {
        ...state,
        loading: true,
      };
    case GET_TIKTOK_ADVERTISERS.response:
      const { advertisers } = action.data;
      return {
        ...state,
        advertisers: advertisers,
        loading: false,
      };

    default:
      return state;
  }
}

const TikTok = ReduxAsyncActionsService.wrapReducer(INIT_STATE, handler, {
  request: [GET_TIKTOK_AUTHENTICATION_URL, GET_SAN_PARTNERS_GET_AD_ACCOUNT_ZEIT_STATUS, GET_TIKTOK_ADVERTISERS],
  error: [GET_TIKTOK_AUTHENTICATION_URL, GET_SAN_PARTNERS_GET_AD_ACCOUNT_ZEIT_STATUS, GET_TIKTOK_ADVERTISERS],
  resetOn: ['APP_CHANGE'],
});

export default TikTok;
